import React, { useState } from "react";
import PeriodSelection from "./../PeriodSelection";
import * as Utils from "utils/utils";
import Const from "const.json";
import { SelectionTypeEnum } from "enums/enums";
import { useAppSelector } from "../../../../redux/hooks";
import { PeriodState } from "types/PeriodSelectionTypes";
import "./PeriodPicker.scss";
import { handleKeyDownEvent, renderPeriod } from "utils/utilsLogic";

const PeriodPicker: React.FC = () => {
  const [isPeriodSelectionVisible, setIsPeriodSelectionVisible] =
    useState(false);
  const { period } = useAppSelector((state) => state.general);

  const [unsavedPeriods, setUnsavedPeriods] = useState<PeriodState>(period);

  const handlePeriodChange = (
    type: SelectionTypeEnum,
    valueString: string,
    valueIndexes: number[]
  ) => {
    const currentField = period[type];
    const isTextChanged = currentField.text !== valueString;
    const isIndexesChanged =
      JSON.stringify(currentField.indexes) !== JSON.stringify(valueIndexes);
    if (isTextChanged || isIndexesChanged) {
      setUnsavedPeriods({
        ...unsavedPeriods,
        [type]: { text: valueString, indexes: valueIndexes },
      });
    }
  };

  const togglePeriodSelection = () => {
    setIsPeriodSelectionVisible(!isPeriodSelectionVisible);
  };
  return (
    <div className="PeriodPickerComp d-flex">
      <div
        className="periodSelection p-2 col-12"
        onClick={togglePeriodSelection}
        tabIndex={0}
        onKeyDown={(event) => handleKeyDownEvent(event, togglePeriodSelection)}
        role="button"
      >
        <div>{Const.periodSelection}</div>
        <div className="d-flex ">
          <div className="bold ps-3">
            {renderPeriod(
              Const.yearOf,
              period.year.text,
              `${Const.yearOf} ${Utils.currentYear}`
            )}
          </div>
          <div className="bold ps-3">
            {renderPeriod(Const.quarters, period.quarterly.text)}
          </div>
          <div className="bold ps-3">
            {renderPeriod(Const.months, period.month.text)}
          </div>
          <div>&nbsp;{`${Const.updateToDate}${Utils.formatDate()}`}</div>
        </div>
      </div>
      {isPeriodSelectionVisible && (
        <PeriodSelection
          closePopup={togglePeriodSelection}
          onChange={handlePeriodChange}
          unsavedPeriods={unsavedPeriods}
          setUnsavedPeriods={setUnsavedPeriods}
        />
      )}
    </div>
  );
};

export default PeriodPicker;
